import {
	fitingovaya_platforma,
	gruzovik,
	khoper,
	konteyner,
	konteynerovoz,
	lesovoz,
	platforma,
	poluvagon,
	skrytyy_vagon,
	tsisterna,
} from '../assets';

const RAILWAY_CARRIAGE_ITEMS = [
	{
		src: skrytyy_vagon,
		title: 'Крытый вагон',
		description:
			'предназначен для перевозки грузов, требующих защиты от атмосферных осадков: сахар, мука, масло, консервы, овощи, строительные материалы и др.',
		type: 1,
	},
	{
		src: poluvagon,
		title: 'Полувагон',
		description:
			'предназначен для перевозки грузов, не требующих защиты от атмосферных осадков: сыпучие грузы (уголь, щебень, песок, руда и др.), металопрокат, пиломатериалы, кирпич и др.',
		type: 2,
	},
	{
		src: platforma,
		title: 'Платформа',
		description:
			'используется для перевозки длинномерных, штучных грузов, оборудования, не требующих защиты от атмосферных воздействий: экскаваторы, военная техника, железобетонные изделия, трансформаторы и др.',
		type: 3,
	},
	{
		src: khoper,
		title: 'Крытый хоппер – зерновоз',
		description:
			'Предназначен для перевозки зерновых грузов: соя, гречка, кукуруза и др., имеющий загрузочные люки на крыше.',
		type: 4,
	},
	{
		src: tsisterna,
		title: 'Цистерна',
		description:
			'предназначена для перевозки: жидкости (нефть, химически активные и агрессивные жидкие вещества), сжиженные газы, вода, масла, патока, спирт и др.',
		type: 5,
	},
	{
		src: lesovoz,
		title: 'Платформа-лесовоз',
		description:
			'специализируется для перевозки лесоматериалов, не требующих защиты от осадков.',
		type: 6,
	},
	{
		src: fitingovaya_platforma,
		title: 'Фитинговая платформа',
		description:
			'предназначена для перевозки крупнотоннажных контейнеров, длиннобазной техники и др.',
		type: 7,
	},
	{
		src: konteyner,
		title: 'Контейнер',
		description:
			'является стандартизированной многооборотной тарой, предназначенной для перевозки грузов автомобильным, железнодорожным, морским и воздушным транспортом и приспособлен для механизированной перегрузки с одного транспортного средства на другое.',
		type: 8,
	},
];

export default RAILWAY_CARRIAGE_ITEMS;
